import React, { FC } from "react";
import styled from "styled-components";

export const FIREWORK_FG_FRAME_ID = "firework-foreground";
const ForegroundFireworkFrame: FC = () => <Root id={FIREWORK_FG_FRAME_ID} />;
export default ForegroundFireworkFrame;

const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 1200;
  opacity: 1;
`;
